const identityNormalizer = pathTemplate => pathTemplate;
export default identityNormalizer;